module.exports = __webpack_public_path__ + "img/titlle.c2f06b7.png";